function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }
function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import Block from '../blots/block.js';
import Container from '../blots/container.js';
var TableCell = /*#__PURE__*/function (_Block) {
  _inherits(TableCell, _Block);
  var _super = _createSuper(TableCell);
  function TableCell() {
    _classCallCheck(this, TableCell);
    return _super.apply(this, arguments);
  }
  _createClass(TableCell, [{
    key: "cellOffset",
    value: function cellOffset() {
      if (this.parent) {
        return this.parent.children.indexOf(this);
      }
      return -1;
    }
  }, {
    key: "format",
    value: function format(name, value) {
      if (name === TableCell.blotName && value) {
        this.domNode.setAttribute('data-row', value);
      } else {
        _get(_getPrototypeOf(TableCell.prototype), "format", this).call(this, name, value);
      }
    }
  }, {
    key: "row",
    value: function row() {
      return this.parent;
    }
  }, {
    key: "rowOffset",
    value: function rowOffset() {
      if (this.row()) {
        return this.row().rowOffset();
      }
      return -1;
    }
  }, {
    key: "table",
    value: function table() {
      return this.row() && this.row().table();
    }
  }], [{
    key: "create",
    value: function create(value) {
      var node = _get(_getPrototypeOf(TableCell), "create", this).call(this);
      if (value) {
        node.setAttribute('data-row', value);
      } else {
        node.setAttribute('data-row', tableId());
      }
      return node;
    }
  }, {
    key: "formats",
    value: function formats(domNode) {
      if (domNode.hasAttribute('data-row')) {
        return domNode.getAttribute('data-row');
      }
      return undefined;
    }
  }]);
  return TableCell;
}(Block);
_defineProperty(TableCell, "blotName", 'table');
_defineProperty(TableCell, "tagName", 'TD');
var TableRow = /*#__PURE__*/function (_Container) {
  _inherits(TableRow, _Container);
  var _super2 = _createSuper(TableRow);
  function TableRow() {
    _classCallCheck(this, TableRow);
    return _super2.apply(this, arguments);
  }
  _createClass(TableRow, [{
    key: "checkMerge",
    value: function checkMerge() {
      // @ts-expect-error
      if (_get(_getPrototypeOf(TableRow.prototype), "checkMerge", this).call(this) && this.next.children.head != null) {
        // @ts-expect-error
        var thisHead = this.children.head.formats();
        // @ts-expect-error
        var thisTail = this.children.tail.formats();
        // @ts-expect-error
        var nextHead = this.next.children.head.formats();
        // @ts-expect-error
        var nextTail = this.next.children.tail.formats();
        return thisHead.table === thisTail.table && thisHead.table === nextHead.table && thisHead.table === nextTail.table;
      }
      return false;
    }
  }, {
    key: "optimize",
    value: function optimize(context) {
      var _this = this;
      _get(_getPrototypeOf(TableRow.prototype), "optimize", this).call(this, context);
      this.children.forEach(function (child) {
        if (child.next == null) return;
        var childFormats = child.formats();
        var nextFormats = child.next.formats();
        if (childFormats.table !== nextFormats.table) {
          var next = _this.splitAfter(child);
          if (next) {
            // @ts-expect-error TODO: parameters of optimize() should be a optional
            next.optimize();
          }
          // We might be able to merge with prev now
          if (_this.prev) {
            // @ts-expect-error TODO: parameters of optimize() should be a optional
            _this.prev.optimize();
          }
        }
      });
    }
  }, {
    key: "rowOffset",
    value: function rowOffset() {
      if (this.parent) {
        return this.parent.children.indexOf(this);
      }
      return -1;
    }
  }, {
    key: "table",
    value: function table() {
      return this.parent && this.parent.parent;
    }
  }]);
  return TableRow;
}(Container);
_defineProperty(TableRow, "blotName", 'table-row');
_defineProperty(TableRow, "tagName", 'TR');
var TableBody = /*#__PURE__*/function (_Container2) {
  _inherits(TableBody, _Container2);
  var _super3 = _createSuper(TableBody);
  function TableBody() {
    _classCallCheck(this, TableBody);
    return _super3.apply(this, arguments);
  }
  return _createClass(TableBody);
}(Container);
_defineProperty(TableBody, "blotName", 'table-body');
_defineProperty(TableBody, "tagName", 'TBODY');
var TableContainer = /*#__PURE__*/function (_Container3) {
  _inherits(TableContainer, _Container3);
  var _super4 = _createSuper(TableContainer);
  function TableContainer() {
    _classCallCheck(this, TableContainer);
    return _super4.apply(this, arguments);
  }
  _createClass(TableContainer, [{
    key: "balanceCells",
    value: function balanceCells() {
      var _this2 = this;
      var rows = this.descendants(TableRow);
      var maxColumns = rows.reduce(function (max, row) {
        return Math.max(row.children.length, max);
      }, 0);
      rows.forEach(function (row) {
        new Array(maxColumns - row.children.length).fill(0).forEach(function () {
          var value;
          if (row.children.head != null) {
            value = TableCell.formats(row.children.head.domNode);
          }
          var blot = _this2.scroll.create(TableCell.blotName, value);
          row.appendChild(blot);
          // @ts-expect-error TODO: parameters of optimize() should be a optional
          blot.optimize(); // Add break blot
        });
      });
    }
  }, {
    key: "cells",
    value: function cells(column) {
      return this.rows().map(function (row) {
        return row.children.at(column);
      });
    }
  }, {
    key: "deleteColumn",
    value: function deleteColumn(index) {
      // @ts-expect-error
      var _this$descendant = this.descendant(TableBody),
        _this$descendant2 = _slicedToArray(_this$descendant, 1),
        body = _this$descendant2[0];
      if (body == null || body.children.head == null) return;
      body.children.forEach(function (row) {
        var cell = row.children.at(index);
        if (cell != null) {
          cell.remove();
        }
      });
    }
  }, {
    key: "insertColumn",
    value: function insertColumn(index) {
      var _this3 = this;
      // @ts-expect-error
      var _this$descendant3 = this.descendant(TableBody),
        _this$descendant4 = _slicedToArray(_this$descendant3, 1),
        body = _this$descendant4[0];
      if (body == null || body.children.head == null) return;
      body.children.forEach(function (row) {
        var ref = row.children.at(index);
        // @ts-expect-error
        var value = TableCell.formats(row.children.head.domNode);
        var cell = _this3.scroll.create(TableCell.blotName, value);
        row.insertBefore(cell, ref);
      });
    }
  }, {
    key: "insertRow",
    value: function insertRow(index) {
      var _this4 = this;
      // @ts-expect-error
      var _this$descendant5 = this.descendant(TableBody),
        _this$descendant6 = _slicedToArray(_this$descendant5, 1),
        body = _this$descendant6[0];
      if (body == null || body.children.head == null) return;
      var id = tableId();
      var row = this.scroll.create(TableRow.blotName);
      body.children.head.children.forEach(function () {
        var cell = _this4.scroll.create(TableCell.blotName, id);
        row.appendChild(cell);
      });
      var ref = body.children.at(index);
      body.insertBefore(row, ref);
    }
  }, {
    key: "rows",
    value: function rows() {
      var body = this.children.head;
      if (body == null) return [];
      return body.children.map(function (row) {
        return row;
      });
    }
  }]);
  return TableContainer;
}(Container);
_defineProperty(TableContainer, "blotName", 'table-container');
_defineProperty(TableContainer, "tagName", 'TABLE');
TableContainer.allowedChildren = [TableBody];
TableBody.requiredContainer = TableContainer;
TableBody.allowedChildren = [TableRow];
TableRow.requiredContainer = TableBody;
TableRow.allowedChildren = [TableCell];
TableCell.requiredContainer = TableRow;
function tableId() {
  var id = Math.random().toString(36).slice(2, 6);
  return "row-".concat(id);
}
export { TableCell, TableRow, TableBody, TableContainer, tableId };